import { CommonClose2Icon } from '@local/assets/icons'

import Clickable from '@web/components/Clickable'
import ModalContainer from '@web/components/Modal/ModalContainer'
import { ModalComponent } from '@web/components/Modal/types'
import useReactiveSessionStorage from '@web/hooks/useReactiveSessionStorage'
import { CLICK_CODE_DEBUG_MODE_KEY } from '@web/libs/dev/clickCodeDebugMode.state'
import { LANDING_DEBUG_MODE } from '@web/libs/dev/MyplaceDevtools/debugLandingMode'
import { LOCALE_DEBUG } from '@web/libs/dev/MyplaceDevtools/useGlobalMyplaceDevtools'
import { PROPS_VIEWER_MODE_KEY } from '@web/libs/dev/MyplaceDevtools/usePropsViewer'

import styles from '../MyplaceDevtoolsModal/styles.module.scss'

const MyplaceDevtoolsModal: ModalComponent = ({ showModal, confirmModal }) => {
  const [clickCodeDebugMode, setClickCodeDebugMode] = useReactiveSessionStorage<boolean>(CLICK_CODE_DEBUG_MODE_KEY)
  const [propsViewerMode, setPropsViewerMode] = useReactiveSessionStorage<boolean>(PROPS_VIEWER_MODE_KEY)
  const [landingDebugMode, setLandingDebugMode] = useReactiveSessionStorage<boolean>(LANDING_DEBUG_MODE)
  const [debugLocale, setDebugLocale] = useReactiveSessionStorage<string>(LOCALE_DEBUG)

  return (
    <ModalContainer showModal={showModal} className={styles.modal}>
      <div className={styles.contents_area}>
        <h3>마이플레이스 개발자 도구</h3>
        <div>실험실 🧪</div>
        <Clickable onClick={() => setClickCodeDebugMode(!clickCodeDebugMode)}>
          클릭코드 디버그 모드: {clickCodeDebugMode ? 'ON' : 'OFF'}
        </Clickable>
        <br />
        <Clickable onClick={() => setLandingDebugMode(!landingDebugMode)}>
          랜딩 디버그 모드: {landingDebugMode ? 'ON' : 'OFF'}
        </Clickable>
        <br />
        <Clickable onClick={() => setPropsViewerMode(!propsViewerMode)}>
          Props 컴포넌트 모드: {propsViewerMode ? 'ON' : 'OFF'}
        </Clickable>
        <br />
        <span>언어: </span>
        <select value={debugLocale} onChange={e => setDebugLocale(e.target.value)}>
          <option value="ko">한국어</option>
          <option value="en">영어</option>
        </select>
      </div>
      <Clickable className={styles.btn_close} onClick={confirmModal}>
        <CommonClose2Icon className={styles.icon} aria-hidden="true" />
        <span className="place_blind">닫기</span>
      </Clickable>
    </ModalContainer>
  )
}

export default MyplaceDevtoolsModal
